import classNames from "classnames";
import NexGenLogo from "components/NexGenLogo";
import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Navbar.scss";

function Navbar(props) {
  const { onSelectMenu, menuActive, scrollPosition } = props;

  const location = useLocation();
  const navigate = useNavigate();

  const [showMenu, setShowMenu] = useState(false);

  const pathName = location.pathname;
  const isHome = pathName === "/";
  const isJobs = pathName === "/jobs";
  const isJobDetail = pathName.startsWith("/detail-job/");

  /**
   * Navigate về Home và sau đó scroll tới section.
   */
  const navigateToSection = useCallback(
    (section) => {
      setShowMenu(false);

      if (isHome) {
        onSelectMenu(section);
        return;
      }

      navigate("/", {
        state: {
          menuSelect: section,
        },
      });
    },
    [isHome, navigate, onSelectMenu],
  );

  const handleNavigate = useCallback(
    (path) => {
      setShowMenu(false);
      navigate(path);
    },
    [navigate],
  );

  const handleClickHome = useCallback(() => {
    setShowMenu(false);

    if (!isHome) {
      navigate("/");
      return;
    }

    onSelectMenu("home");
  }, [isHome, navigate, onSelectMenu]);

  const handleShowMenu = useCallback(() => {
    setShowMenu((prev) => !prev);
  }, []);

  return (
    <div className="nav-wrapper">
      {/* ================= DESKTOP ================= */}
      <div className="navbar">
        <div className="main-left">
          <button
            className="logo-button"
            onClick={handleClickHome}
            aria-label="Go to home"
          >
            <NexGenLogo />
          </button>
        </div>

        <div className="main-right">
          <ul className="nav-content">
            {/* HOME */}
            <li
              className={classNames("nav-item", {
                select:
                  isHome && menuActive === "home" && scrollPosition <= 600,
              })}
              onClick={handleClickHome}
            >
              Home
            </li>

            {/* SERVICES */}
            <li
              className={classNames("nav-item", {
                select:
                  isHome &&
                  menuActive === "service" &&
                  scrollPosition > 600 &&
                  scrollPosition < 2600,

                hide: !isHome,
              })}
              onClick={() => navigateToSection("service")}
            >
              Services
            </li>

            {/* JOBS */}
            <li
              className={classNames("nav-item", {
                select: isJobs || isJobDetail,
              })}
              onClick={() => handleNavigate("/jobs")}
            >
              Jobs
            </li>

            {/* ABOUT */}
            <li
              className={classNames("nav-item", {
                select:
                  isHome &&
                  menuActive === "about" &&
                  scrollPosition > 2800 &&
                  scrollPosition < 3700,

                hide: !isHome,
              })}
              onClick={() => navigateToSection("about")}
            >
              About us
            </li>

            {/* CONTACT */}
            <button
              className={classNames("contact-btn", {
                hide: !isHome,
              })}
              onClick={() => navigateToSection("contact")}
            >
              Contact us
            </button>
          </ul>
        </div>
      </div>

      {/* ================= MOBILE ================= */}
      <div className="navbar-mobile">
        {showMenu && (
          <div className="bg-overplay" onClick={() => setShowMenu(false)} />
        )}

        <div className="main-left">
          <button
            className="logo-button"
            onClick={handleClickHome}
            aria-label="Go to home"
          >
            <NexGenLogo />
          </button>
        </div>

        <div className="main-right">
          <button
            className="btn-hamburger"
            type="button"
            onClick={handleShowMenu}
          >
            <img
              src={require("assets/images/icons/hamburger.png")}
              className="icon-menu"
              alt=""
            />
          </button>

          <div
            className={classNames("navbar-child", {
              show: showMenu,
            })}
          >
            <ul className="nav-content">
              {/* HOME */}
              <li
                className={classNames("nav-item", {
                  select:
                    isHome && menuActive === "home" && scrollPosition < 300,
                })}
                onClick={handleClickHome}
              >
                Home
              </li>

              {/* SERVICES */}
              <li
                className={classNames("nav-item", {
                  select:
                    isHome &&
                    (menuActive === "service" ||
                      (scrollPosition > 300 && scrollPosition < 3000)),

                  hide: !isHome,
                })}
                onClick={() => navigateToSection("service")}
              >
                Services
              </li>

              {/* JOBS */}
              <li
                className={classNames("nav-item", {
                  select: isJobs || isJobDetail,
                  rmb: isJobs || isJobDetail,
                })}
                onClick={() => handleNavigate("/jobs")}
              >
                Jobs
              </li>

              {/* ABOUT */}
              <li
                className={classNames("nav-item", {
                  select:
                    isHome &&
                    (menuActive === "about" ||
                      (scrollPosition >= 3000 && scrollPosition < 4000)),

                  hide: !isHome,
                })}
                onClick={() => navigateToSection("about")}
              >
                About us
              </li>

              {/* CONTACT */}
              <button
                className={classNames("nav-btn", {
                  select: isHome && menuActive === "contact",
                  hide: !isHome,
                })}
                onClick={() => navigateToSection("contact")}
              >
                Contact us
              </button>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
